module.exports = __webpack_public_path__ + "media/eat1.4f4d544d.mp4";